// extracted by mini-css-extract-plugin
export default {"card":"Card_card__zQfcO","icon":"Card_icon__0D7+y","title":"Card_title__fjt9r","desc":"Card_desc__dIirN"};